import "core-js/modules/es6.object.assign";
import * as encode from './encode';
export var line = {
  vgMark: 'line',
  encodeEntry: function encodeEntry(model) {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, encode.baseEncodeEntry(model, {
      align: 'ignore',
      baseline: 'ignore',
      color: 'include',
      size: 'ignore',
      orient: 'ignore'
    })), encode.pointPosition('x', model, {
      defaultPos: 'mid'
    })), encode.pointPosition('y', model, {
      defaultPos: 'mid'
    })), encode.nonPosition('size', model, {
      vgChannel: 'strokeWidth' // VL's line size is strokeWidth

    })), encode.defined(model));
  }
};
export var trail = {
  vgMark: 'trail',
  encodeEntry: function encodeEntry(model) {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, encode.baseEncodeEntry(model, {
      align: 'ignore',
      baseline: 'ignore',
      color: 'include',
      size: 'include',
      orient: 'ignore'
    })), encode.pointPosition('x', model, {
      defaultPos: 'mid'
    })), encode.pointPosition('y', model, {
      defaultPos: 'mid'
    })), encode.nonPosition('size', model)), encode.defined(model));
  }
};